export const enum AutocompleteViewStoreEvent {
  enterPressed = 'enterPressed',
}
